module.exports = __webpack_public_path__ + "img/network.d3f657bb.svg";